import React from "react";
import { Helmet } from "react-helmet";

const SITE_NAME = "Endgame Sport Dogs";
const SITE_URL = "https://endgamedogs.com";
const DEFAULT_DESCRIPTION =
  "Endgame Sport Dogs breeds and trains health-tested border collies and sport mixes near Raleigh, North Carolina for agility, flyball, dock diving, herding, disc, and active sport homes.";
const DEFAULT_IMAGE = `${SITE_URL}/apple-icon.png`;

function normalizePath(path) {
  if (!path || path === "/index") {
    return "/";
  }

  return path.startsWith("/") ? path : `/${path}`;
}

function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  appendSiteName = true
}) {
  const pageTitle = title ? `${title}${appendSiteName ? ` | ${SITE_NAME}` : ""}` : SITE_NAME;
  const canonicalPath = normalizePath(path);
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default SEO;
